import { render, staticRenderFns } from "./AddCustomerModal.vue?vue&type=template&id=1834ce97&scoped=true"
import script from "./AddCustomerModal.vue?vue&type=script&lang=js"
export * from "./AddCustomerModal.vue?vue&type=script&lang=js"
import style0 from "./AddCustomerModal.vue?vue&type=style&index=0&id=1834ce97&prod&lang=scss"
import style1 from "./AddCustomerModal.vue?vue&type=style&index=1&id=1834ce97&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1834ce97",
  null
  
)

export default component.exports